import {SaleVehiclePhotoTypeSchema} from '@dms/api/settings';

import {PHOTO_GUIDE_SLOT_DND_ID_PREFIX} from '../constants/PHOTO_GUIDE_SLOT_DND_ID_PREFIX';

/** The Photo Type of an empty slot's dnd item id, or `null` for any other id. */
export const parsePhotoGuideSlotDndId = (id: string) => {
  if (!id.startsWith(PHOTO_GUIDE_SLOT_DND_ID_PREFIX)) {
    return null;
  }
  const photoType = SaleVehiclePhotoTypeSchema.safeParse(
    id.slice(PHOTO_GUIDE_SLOT_DND_ID_PREFIX.length)
  );
  return photoType.success ? photoType.data : null;
};
